import { render, staticRenderFns } from "./WidgetAttributeForm.vue?vue&type=template&id=6bc91425"
import script from "./WidgetAttributeForm.vue?vue&type=script&lang=js"
export * from "./WidgetAttributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports